module.exports = __webpack_public_path__ + "img/VP-UltraLine-Repairing.2122aa70.jpg";